import type { BrowserIdentityService } from '../auth/BrowserIdentityService';
import type { AudioRuntime } from '../game/audio/AudioRuntime';
import { t } from '../i18n';
import { ChatAudioFeedback } from '../chat/ChatAudioFeedback';
import { ChatModel } from '../chat/ChatModel';
import { ChatPanel } from '../chat/ChatPanel';
import { GlobalChatClient } from '../chat/GlobalChatClient';
import './online.css';

export function mountGlobalChat(host: HTMLElement, identity: BrowserIdentityService, audioRuntime: AudioRuntime): () => void {
  const model = new ChatModel('global');
  let localAuthorId: string | null = null;
  const audio = new ChatAudioFeedback(model, audioRuntime, { localAuthorId: () => localAuthorId });
  const releaseAudioUnlock = audio.bindUnlockGestures(window);
  void audio.preload().catch(() => undefined);
  const panel: ChatPanel = new ChatPanel({ model, placement: 'bottom-left',
    composerMode: 'persistent', variant: 'home',
    labels: {
      title: t('chat:global.title'),
      placeholder: t('chat:global.placeholder'),
    },
    onSend: (text): Promise<void> => client.send(text),
    onSendAccepted: () => audio.playSent(),
  });
  const client: GlobalChatClient = new GlobalChatClient({ url: identity.globalChatUrl, getSession: async () => {
    const session = await identity.getOnlineSession();
    localAuthorId = session.identity.id;
    return session;
  }, model, panel,
  });
  host.append(panel.element);
  void client.start().catch(() => panel.setSendEnabled(false, t('chat:global.temporarilyUnavailable')));
  return () => { releaseAudioUnlock(); client.dispose(); panel.dispose(); audio.dispose(); };
}
